module.exports = __webpack_public_path__ + "img/Comic07-1.2bb4c258.png";